import excelToJson from '/utils/convert-excel-to-json.js'
import _ from 'lodash'

const parseUploadedData = ({ base64Data, file, requireJsonArray = false }) => {

  try {
    const filetype = file.name.split(".").pop()

    let content

    switch (filetype) {
      case "xlsx": {
        const buffer = Buffer.from(base64Data, "base64")
        const ed = excelToJson({ source: buffer, type: "buffer" })
        const sheets = Object.keys(ed)
        const structuredData = ed[sheets[0]]

        let sheetrows = []
        let headerRows = []

        let type = "header"

        structuredData.map(i => {
          if (i.A === '-- -- -- -- --') {
            type = "body"
          } else {
            if (type === "body") {
              const keys = Object.keys(i)
              let allValues = ""

              for (let k in keys) allValues += i[keys[k]]

              if (allValues.length) sheetrows.push(i)
            }
            else {
              headerRows.push(i)
            }
          }
        })

        const columnPaths = getColumnPaths(headerRows)

        content = sheetrows.map(row => {
          let item = {}

          for (let letter in row) {
            const path = columnPaths[letter]
            const value = normaliseExcelUploadedValue(row[letter])
            if (path && value !== undefined) _.set(item, path, value)
          }
          return item
        })

        break
      }

      case "csv": {
        const data = atob(base64Data)

        content = []

        const rows = data.split("\n")
        let header = rows.shift()
        header = header.split(",").map(item => item.trim())

        rows.map(r => {
          const row = r.split(",")

          let data_item = {}

          row.map((item, idx) => {
            const path = header[idx]
            const value = normaliseUploadedValue(item, true)
            if (path && value !== undefined) _.set(data_item, path, value)
          })
          if (Object.keys(data_item).length) content.push(data_item)
        })

        break
      }

      case "json": {
        const data = atob(base64Data)
        content = normaliseJsonUploadedData(JSON.parse(data))
        if (requireJsonArray && !Array.isArray(content)) {
          throw new Error("JSON upload must be an array of pass variable objects.")
        }
        break
      }
    }

    // We need an array. Make one here if user uploaded a single pass JSON object
    if (!Array.isArray(content)) content = [content]

    return content
  }
  catch (err) {
    console.log(err)
  }
}

export default parseUploadedData

const normaliseUploadedValue = (value, parseNull = false) => {
  if (typeof value !== 'string') return value

  const cleanedValue = value.trim()
  if (!cleanedValue) return undefined
  if (cleanedValue.toLowerCase() === '[empty]') return ''
  return parseNull && cleanedValue === "NULL" ? null : cleanedValue
}

const normaliseExcelUploadedValue = value => {
  if (value === null) return undefined
  if (value === undefined) return undefined
  return normaliseUploadedValue(value)
}

const normaliseJsonUploadedData = value => {
  if (typeof value === 'string') return normaliseUploadedValue(value)
  if (Array.isArray(value)) return value.map(normaliseJsonUploadedData)
  if (!_.isPlainObject(value)) return value

  return Object.entries(value).reduce((item, [key, childValue]) => {
    const normalisedChildValue = normaliseJsonUploadedData(childValue)
    if (normalisedChildValue !== undefined) _.set(item, key, normalisedChildValue)
    return item
  }, {})
}

const getColumnPaths = headerRows => {
  const columns = _.uniq(headerRows.flatMap(row => Object.keys(row)))
    .sort((a, b) => excelColumnToNumber(a) - excelColumnToNumber(b))
  const inheritedHeaders = []

  return columns.reduce((paths, column) => {
    const headers = headerRows.map(row => getHeaderValue(row[column]))
    const lastHeaderIndex = headers.reduce((lastIndex, value, index) => value === undefined ? lastIndex : index, -1)

    if (lastHeaderIndex === -1) return paths

    const path = headers
      .slice(0, lastHeaderIndex + 1)
      .map((value, index) => {
        if (value !== undefined) inheritedHeaders[index] = value
        return inheritedHeaders[index]
      })
      .filter(value => value !== undefined)
      .join('.')

    if (path) paths[column] = path
    return paths
  }, {})
}

const getHeaderValue = value => {
  if (typeof value === 'string') value = value.trim()
  return value === '' || value === null || value === undefined ? undefined : value
}

const excelColumnToNumber = column => column.split('').reduce((number, letter) => number * 26 + letter.charCodeAt(0) - 64, 0)
